import React from "react";
import AntdUpload, { UploadProps } from "antd/lib/upload";
import {withError} from '@fishx/tracker';

const Dragger = AntdUpload.Dragger;

interface FCUploadProps extends React.FC<UploadProps> {
  Dragger: typeof Dragger;
}
export const Upload: FCUploadProps = (props) => {
  return (
    <AntdUpload {...props} />
  )
}
Upload.Dragger = Dragger;
Upload.displayName = 'Upload';
export default withError(Upload);



// WEBPACK FOOTER //
// ./src/components/upload/index.tsx